import type { RootState } from '@app/store';

export const selectAuthSipAor = (state: RootState) => state.auth.user?.sipAor;
export const selectAuthUser = (state: RootState) => state.auth.user;
export const selectIsAuthorized = (state: RootState) => state.auth.isAuthorized;
